import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { OptionSubCategory, SubCategoryState, Option } from 'owa-options-core';
import { getCurrentSubcategory, getStore, getCurrentSubcategoryLoadState } from 'owa-options-store';
import { AnimationClassNames } from '@uifabric/styling';
import SettingsFormHeader from './SettingsFormHeader';
import SettingsFormFooter from './SettingsFormFooter';
import { OptionsPaneLoading } from 'owa-options-loading';
import OptionsPane from './OptionsPane';
import OptionsPaneError from './OptionsPaneError';
import { tryLoadAllFullOptionsSync } from 'owa-options-core';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface SettingsColumnProps {
    onOpenFlyout?(): void;
}

const renderOptionsPane = (options: Option[]) => {
    switch (getCurrentSubcategoryLoadState()) {
        case SubCategoryState.Loading:
            return <OptionsPaneLoading />;
        case SubCategoryState.Loaded:
            return options ? <OptionsPane options={options} /> : <OptionsPaneLoading />;
        case SubCategoryState.Error:
        default:
            return <OptionsPaneError />;
    }
};

export default observer(function SettingsColumn({ onOpenFlyout }: SettingsColumnProps) {
    const selectedSubCategory: OptionSubCategory =
        getCurrentSubcategory() || ({} as OptionSubCategory);
    const { currentSubCategoryKey } = getStore();
    const options: Option[] = tryLoadAllFullOptionsSync(selectedSubCategory);

    return (
        <div
            className={className(styles.settingsPane, AnimationClassNames.slideLeftIn20)}
            role="tabpanel"
            key={currentSubCategoryKey}>
            <SettingsFormHeader
                selectedSubCategory={selectedSubCategory}
                onOpenFlyout={onOpenFlyout}
            />
            {renderOptionsPane(options)}
            {getCurrentSubcategoryLoadState() === SubCategoryState.Loaded && (
                <SettingsFormFooter selectedSubCategory={selectedSubCategory} />
            )}
        </div>
    );
});
